// src/components/SearchBar.jsx
import React, { useState, useEffect } from 'react';
import './SearchBar.css';

function SearchBar({ onSearch, value = '', onChange = () => {}, filmReelIcon }) {
  const [query, setQuery] = useState(value);
  
  // Update local state when the external value changes
  useEffect(() => {
    setQuery(value);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setQuery(newValue);
    onChange(newValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <div className="search-bar">
      <form onSubmit={handleSubmit}>
        {filmReelIcon && (
          <div className="search-icon-container">
            {filmReelIcon}
          </div>
        )}
        <input
          type="text"
          placeholder="Search movies, actors, or simply describe what you're looking for..."
          value={query}
          onChange={handleChange}
        />
        <button type="submit">Search</button>
      </form>
    </div>
  );
}

export default SearchBar;